import React from 'react';
import { Link } from 'react-router'
import $ from 'jquery'

let config = require('config');
let backArrow   = require('../images/back_arrow.svg')
let backArrowHover = require('../images/back_arrow_ov.svg')

var id = ""

class TopicsDetail extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMobile:false,
      isBackArrowHover:false
    }
  }

  componentDidMount() {
    const { actions, params } = this.props;
    actions.getTopicsById(params.slug)

    $(window).on("resize", this.resize.bind(this))
    this.resize()
  }

  componentWillUnmount() {
    $(window).off("resize")
  }

  render() {
    const { actions, data } = this.props;
    var topic = data.topicsSingle;

    if (topic) {
      document.title = topic.title + " | TOPICS | " + config.default.SITE_NAME
    }

    return (
      <div id="topics-detail" className="main detail">
        { topic ?
            <div className="topics-detail_inner">
              { !this.state.isMobile ?
                  <div className="topics-detail__header">
                    <Link to={"/topics/"}><img className="def" src={backArrow} /><img className="ov" src={backArrowHover} /></Link>
                  </div>
                :null
              }
              <div className="topics-detail__mainvisual">
                <img src={topic.image.url} />
              </div>
              <div className="topics-detail__content">
                <h1 className="content__title">{topic.title}</h1>
                <div className="content__body">
                  <div className="body__side">
                    <div className="side__date">{topic.date}</div>
                  </div>
                  <div className="body__text" dangerouslySetInnerHTML={{__html:topic.text}} />
                </div>
              </div>
            </div>
          :null
        }
      </div>
    );
  }

  resize() {
    var w = $(window).width()
    var h = $(window).height()
    if (w < config.default.MEDIA_ALL_MOBILE) {
      if (!this.state.isMobile) {
        this.setState({ isMobile:true });
      }
    } else {
      if (this.state.isMobile) {
        this.setState({ isMobile:false });
      }
    }
  }
}

TopicsDetail.displayName = 'TopicsDetail';
TopicsDetail.propTypes = {};
TopicsDetail.defaultProps = {};

export default TopicsDetail;




// WEBPACK FOOTER //
// ./components/TopicsDetail.js